/* First Image Rule — groups the product gallery by variant. Simply Carbon Fiber's own file
   (2026-09-10), replacing the Easy Variant Images app. Each variant's featured image is its
   anchor; the variant shows every image from its anchor up to (not including) the next
   variant's anchor. Images before the first anchor show for every variant; a variant with no
   featured image shows all images. Variants sharing a featured image share a group.
   It rides Impulse's own image-set slider path (settings.imageSetName → imageSetArguments /
   updateImageSet / updateImageSetThumbs) so theme.js is untouched. Loaded BEFORE theme.js:
   Impulse creates its section instances synchronously at the end of theme.js, so this hooks
   theme.Product the moment theme.js assigns it. Switch: Theme settings > Product gallery. */
(function () {
  var SET = 'variant-groups';

  // variants: the theme's parsed [data-variant-json]; slideCount: number of media slides.
  // Returns { byPos: {position: [variantId...] | ['all']}, keyOf: {variantId: variantId | 'all'} }
  // or null when grouping would not change anything.
  function computeGroups(variants, slideCount) {
    var anchors = variants.filter(function (v) { return v.featured_media && v.featured_media.position; })
      .map(function (v) { return { id: String(v.id), pos: v.featured_media.position }; })
      .sort(function (a, b) { return a.pos - b.pos; });
    if (!anchors.length || slideCount < 2) return null;
    var byPos = {}, keyOf = {}, meaningful = false;
    for (var p = 1; p <= slideCount; p++) {
      var owner = null;
      for (var i = 0; i < anchors.length && anchors[i].pos <= p; i++) owner = anchors[i].pos;
      byPos[p] = owner === null ? ['all'] : anchors.filter(function (a) { return a.pos === owner; }).map(function (a) { return a.id; });
    }
    variants.forEach(function (v) {
      var id = String(v.id), anchored = anchors.some(function (a) { return a.id === id; });
      keyOf[id] = anchored ? id : 'all';
      if (anchored) for (var q = 1; q <= slideCount; q++) if (byPos[q][0] !== 'all' && byPos[q].indexOf(id) === -1) meaningful = true;
    });
    return meaningful ? { byPos: byPos, keyOf: keyOf } : null;
  }
  function computeExplicitGroups(variants, slides, galleries) {
    var byPos = {}, keyOf = {}, orderOf = {}, positions = Object.create(null);
    slides.forEach(function (slide) {
      var position = Number(slide.getAttribute('data-index')) + 1;
      positions[String(slide.getAttribute('data-media-id'))] = position;
      byPos[position] = [];
    });
    variants.forEach(function (variant) {
      var id = String(variant.id), refs = galleries[id];
      var valid = Array.isArray(refs) ? refs.filter(function (mediaId) { return positions[String(mediaId)] !== undefined; }) : [];
      if (!valid.length && variant.featured_media) valid = [variant.featured_media.id];
      keyOf[id] = id;
      orderOf[id] = [];
      valid.forEach(function (mediaId) {
        var position = positions[String(mediaId)];
        if (position !== undefined && byPos[position].indexOf(id) === -1) {
          byPos[position].push(id);
          orderOf[id].push(String(mediaId));
        }
      });
    });
    Object.keys(byPos).forEach(function (position) { if (!byPos[position].length) byPos[position] = ['none']; });
    return { byPos: byPos, keyOf: keyOf, orderOf: orderOf, explicit: true };
  }
  if (typeof globalThis !== 'undefined') globalThis.VariantImageGroups = { computeGroups: computeGroups };
  if (typeof window === 'undefined' || typeof document === 'undefined') return;

  function enabled() { return !(window.theme && theme.settings && theme.settings.variantImageGroups === false); }
  function stamp(el, tokens) { el.setAttribute('data-vig', tokens.join(' ')); }
  function inSet(el, set) { var t = (el.getAttribute('data-vig') || 'all').split(' '); return set === 'all' || t.indexOf(set) !== -1 || t.indexOf('all') !== -1; }

  function bindCompactZoom(product) {
    var viewer = product.vigCompact.viewer;
    if (!viewer) return;
    product.cache.mainSlider.querySelectorAll('.js-photoswipe__zoom').forEach(function (button) {
      if (button.__vigZoomBound) return;
      button.__vigZoomBound = true;
      button.addEventListener('click', viewer.triggerClick.bind(viewer));
    });
  }

  function compactNode(product, media, thumbnail, first) {
    var state = product.vigCompact;
    var node = (thumbnail ? state.thumbTemplate : state.slideTemplate).cloneNode(true);
    node.dataset.index = String(media.index);
    node.classList.remove('hide', 'is-selected', 'starting-slide', 'secondary-slide');
    node.removeAttribute('style');
    node.removeAttribute('aria-hidden');
    node.removeAttribute('tabindex');
    stamp(node, product.vig.byPos[media.index + 1] || ['all']);
    var image = node.querySelector('img');
    image.src = thumbnail ? media.thumb : media.src;
    image.srcset = thumbnail ? media.thumb + ' 360w' : media.srcset;
    image.alt = media.alt || '';
    image.width = thumbnail ? 360 : 1080;
    image.height = Math.round(image.width * media.height / media.width);
    image.loading = !thumbnail && first ? 'eager' : 'lazy';
    image.removeAttribute('fetchpriority');
    if (!thumbnail && first) image.setAttribute('fetchpriority', 'high');
    node.querySelectorAll('.image-wrap').forEach(function (wrap) {
      wrap.style.paddingBottom = (100 * media.height / media.width) + '%';
    });
    if (thumbnail) {
      var link = node.querySelector('[data-product-thumb]');
      link.classList.remove('is-active');
      link.dataset.id = String(media.id);
      link.dataset.index = String(media.index);
      link.href = media.zoom;
    } else {
      node.classList.add(first ? 'starting-slide' : 'secondary-slide');
      node.dataset.mediaId = String(media.id);
      image.dataset.index = String(media.index + 1);
      image.dataset.photoswipeSrc = media.zoom;
      image.dataset.photoswipeWidth = String(media.width);
      image.dataset.photoswipeHeight = String(media.height);
    }
    return node;
  }

  function mountCompactGallery(product, variant) {
    var state = product.vigCompact, slider = product.cache.mainSlider;
    variant = variant || (product.variants && product.variants.currentVariant);
    var key = product.vig.keyOf[String(variant && variant.id)] || 'all';
    var media = state.media.filter(function (item) {
      var tokens = product.vig.byPos[item.index + 1] || ['all'];
      return key === 'all' || tokens.indexOf(key) !== -1 || tokens.indexOf('all') !== -1;
    });
    if (product.flickity) { product.flickity.destroy(); product.flickity = null; }
    var slides = Array.prototype.slice.call(slider.querySelectorAll('.product-main-slide'));
    var same = slides.length === media.length && slides.every(function (slide, index) {
      return slide.dataset.mediaId === String(media[index].id);
    });
    // Keep the already loading server-rendered hero on first initialization.
    if (!same) {
      slides.forEach(function (slide) { slide.remove(); });
      media.forEach(function (item, index) { slider.appendChild(compactNode(product, item, false, index === 0)); });
    }
    var holder = product.cache.thumbScroller || product.cache.thumbSlider;
    product.cache.thumbSlider.querySelectorAll('.product__thumb-item').forEach(function (thumb) { thumb.remove(); });
    media.forEach(function (item) { holder.appendChild(compactNode(product, item, true, false)); });
    // The stock slideshow does not detach its navigation handlers on destroy.
    product.cache.thumbSlider.querySelectorAll('.product__thumb-arrow').forEach(function (arrow) {
      arrow.replaceWith(arrow.cloneNode(true));
    });
    product.cache.thumbSlider.classList.toggle('medium-up--hide', media.length <= 1);
    var container = product.container.querySelector('[data-product-images]');
    if (container) container.dataset.hasSlideshow = String(media.length > 1);
    product.settings.currentImageSet = key;
    product.settings.currentSlideIndex = 0;
    state.selected = slider.querySelector('.product-main-slide');
    if (state.selected) state.selected.setAttribute('tabindex', '0');
    bindCompactZoom(product);
  }

  function patch(Product) {
    if (!Product || !Product.prototype || Product.prototype.__vig) return Product;
    var proto = Product.prototype; proto.__vig = true;
    var initImageZoom = proto.initImageZoom, onSlideChange = proto.onSlideChange;
    var formSetup = proto.formSetup, imageSetArguments = proto.imageSetArguments, updateImageSet = proto.updateImageSet, updateImageSetThumbs = proto.updateImageSetThumbs, initProductSlider = proto.initProductSlider;

    proto.formSetup = function () {
      formSetup.apply(this, arguments);
      if (!this.variantsObject || !this.cache.mainSlider) return;
      var galleryData = this.container.querySelector('[data-scf-variant-galleries]'), galleries = null;
      if (galleryData) {
        try { galleries = JSON.parse(galleryData.textContent); } catch (e) { galleries = {}; }
        if (!galleries || typeof galleries !== 'object' || Array.isArray(galleries)) galleries = {};
      }
      // Explicit kit galleries take precedence; ordinary products retain theme grouping settings.
      if (!galleries && (!enabled() || this.settings.imageSetName)) return;
      var slides = this.cache.mainSlider.querySelectorAll('.product-main-slide[data-index]');
      var mediaData = this.container.querySelector('[data-vig-media]'), media = null;
      if (!galleries && mediaData) {
        try { media = JSON.parse(mediaData.textContent).media; } catch (e) { media = null; }
        if (!Array.isArray(media) || !media.length) media = null;
      }
      var g = galleries ? computeExplicitGroups(this.variantsObject, slides, galleries) : computeGroups(this.variantsObject, media ? media.length : slides.length);
      if (!g) return;
      this.vig = g;
      if (media && slides.length && this.cache.thumbSlider) {
        var thumbTemplate = this.cache.thumbSlider.querySelector('.product__thumb-item');
        if (thumbTemplate) this.vigCompact = {
          media: media,
          slideTemplate: slides[0].cloneNode(true),
          thumbTemplate: thumbTemplate.cloneNode(true)
        };
      }
      slides.forEach(function (el) { stamp(el, g.byPos[Number(el.getAttribute('data-index')) + 1] || ['all']); });
      if (this.cache.thumbSlider) this.cache.thumbSlider.querySelectorAll('.product__thumb-item[data-index]').forEach(function (el) { stamp(el, g.byPos[Number(el.getAttribute('data-index')) + 1] || ['all']); });
      this.settings.imageSetName = SET;
      this.container.addEventListener('variantChange', this.updateImageSet.bind(this));
      if (!this.__vigZoomBound) {
        this.__vigZoomBound = true;
        this.container.addEventListener('photoswipe:afterChange', function (evt) {
          if (!this.flickity || !evt.detail) return;
          var cells = this.flickity.slideshow && this.flickity.slideshow.cells;
          if (!cells) return;
          // Stock zoom emits a product-media index, not the filtered gallery position.
          evt.stopImmediatePropagation();
          for (var i = 0; i < cells.length; i++) {
            var slide = cells[i].element;
            if (slide.dataset.index === String(evt.detail.index)) {
              this.flickity.goToSlide(slide.dataset.mediaId);
              return;
            }
          }
        }.bind(this), true);
      }
      this.updateImageSet();
    };
    proto.initProductSlider = function () {
      if (this.vigCompact) mountCompactGallery(this, arguments[0]);
      if (this.vig && this.vig.explicit) {
        if (this.flickity && typeof this.flickity.destroy === 'function') { this.flickity.destroy(); this.flickity = null; }
        var slider = this.cache.mainSlider;
        var variant = arguments[0] || (this.variants && this.variants.currentVariant);
        var order = this.vig.orderOf[String(variant && variant.id)] || [];
        function rank(el) {
          var thumb = el.querySelector('[data-product-thumb]');
          var id = el.getAttribute('data-media-id') || (thumb && thumb.getAttribute('data-id'));
          var index = order.indexOf(String(id));
          return index === -1 ? order.length + Number(el.dataset.index) : index;
        }
        // Keep slideshow and navigation in the configured reference order after every rebuild.
        Array.prototype.slice.call(slider.querySelectorAll('.product-main-slide[data-index]'))
          .sort(function (a, b) { return rank(a) - rank(b); })
          .forEach(function (slide) { slider.appendChild(slide); });
        if (this.cache.thumbSlider) Array.prototype.slice.call(this.cache.thumbSlider.querySelectorAll('.product__thumb-item[data-index]'))
          .sort(function (a, b) { return rank(a) - rank(b); })
          .forEach(function (thumb) { thumb.parentNode.appendChild(thumb); });
      }
      return initProductSlider.apply(this, arguments);
    };
    proto.initImageZoom = function () {
      if (!this.vigCompact) return initImageZoom.apply(this, arguments);
      if (!this.vigCompact.viewer) {
        var container = this.container.querySelector(this.selectors.imageContainer);
        if (!container || container.dataset.zoom === 'false') return;
        // Keep one viewer; newly mounted slides receive only their own button handler.
        this.vigCompact.viewer = new theme.Photoswipe(document.createElement('div'), this.sectionId);
        this.vigCompact.viewer.container = container;
      }
      bindCompactZoom(this);
    };
    proto.onSlideChange = function (index) {
      if (!this.vigCompact) return onSlideChange.apply(this, arguments);
      var cell = this.flickity && this.flickity.slideshow.cells[index];
      if (!cell) return;
      var previous = this.vigCompact.selected, next = cell.element;
      if (previous && previous !== next) previous.setAttribute('tabindex', '-1');
      next.setAttribute('tabindex', '0');
      this.vigCompact.selected = next;
      this.settings.currentSlideIndex = index;
      var thumb = this.cache.thumbSlider.querySelectorAll('.product__thumb-item:not(.hide)')[index];
      if (thumb) thumb.scrollIntoView({block:'nearest', inline:'nearest'});
    };
    proto.imageSetArguments = function (variant) {
      if (this.settings.imageSetName !== SET) return imageSetArguments.apply(this, arguments);
      variant = variant || (this.variants ? this.variants.currentVariant : null);
      if (!variant) return;
      var key = this.settings.currentImageSet = this.vig.keyOf[String(variant.id)] || (this.vig.explicit ? 'none' : 'all');
      this.settings.currentSlideIndex = 0;
      return key === 'all' ? { imageSet: 'all', initialIndex: 0 }
        : { cellSelector: '[data-vig~="' + key + '"], [data-vig~="all"]', imageSet: key, initialIndex: 0 };
    };
    proto.updateImageSet = function (evt) {
      if (this.settings.imageSetName !== SET) return updateImageSet.apply(this, arguments);
      var variant = evt ? evt.detail.variant : (this.variants ? this.variants.currentVariant : null);
      if (!variant) return;
      var key = this.vig.keyOf[String(variant.id)] || (this.vig.explicit ? 'none' : 'all');
      if (this.settings.currentImageSet === key) return;
      this.initProductSlider(variant);
    };
    proto.updateImageSetThumbs = function (set) {
      if (this.settings.imageSetName !== SET) return updateImageSetThumbs.apply(this, arguments);
      if (!this.cache.thumbSlider) return;
      this.cache.thumbSlider.querySelectorAll('.product__thumb-item').forEach(function (thumb) { thumb.classList.toggle('hide', !inSet(thumb, set)); });
    };
    return Product;
  }

  window.theme = window.theme || {};
  if (theme.Product) { patch(theme.Product); return; }
  // theme.js has not run yet: patch the class the moment it is assigned.
  var stored;
  Object.defineProperty(theme, 'Product', {
    configurable: true, enumerable: true,
    get: function () { return stored; },
    set: function (v) { stored = patch(v); }
  });
})();
